import axios from "axios";
import numeral from "numeral";
import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";
import VueAxios from "vue-axios";
import numFormat from "vue-filter-number-format";
import VueRouter from "vue-router";
import App from "./App.vue";
import { router } from "./router";
import { store } from "./Store";

import "@fortawesome/fontawesome-free/js/all.js";
import "bootstrap";

import "@common/directives";

// Enable bootstrap tooltips
$(function () {
  $("body").tooltip({ selector: '[data-toggle="tooltip"]' });
});
Vue.use(PiniaVuePlugin);
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.filter("numFormat", numFormat(numeral));

const pinia = createPinia();

new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  pinia,
});
